import * as amplitude from '@amplitude/analytics-browser';
import CONFIG from '../config/config';

const isEnabled = (): boolean => CONFIG.AMPLITUDE_ENABLED === true;

export function initAmplitude(): void {
  if (!isEnabled()) {
    return;
  }

  amplitude.init(CONFIG.AMPLITUDE, {
    // serverZone: 'EU',
    flushQueueSize: 30,
    flushIntervalMillis: 10000,
    useBatch: true,
  });
}

export function track(eventName: string, eventProperties?: Record<string, unknown>): void {
  if (!isEnabled() || !eventName) {
    return;
  }

  amplitude.track(eventName, eventProperties);
}

export function identifyUser(userId: string): void {
  if (!isEnabled() || !userId) {
    return;
  }

  const identifyObj = new amplitude.Identify();
  identifyObj.set('userId', userId);
  amplitude.identify(identifyObj);
}
